import feFunctions from '../../services/fe-functions';

export default class AuthService {
  constructor(firebase, QueryParamService, EventService, PROVIDERS, $state) {
    'ngInject';
    Object.assign( this, { firebase, PROVIDERS, EventService, $state });
    this._profiles = {};
    this.qps = QueryParamService;
  }

  user() {
    return new Promise((res, rej) => {
      this.firebase.auth().onAuthStateChanged(user => {
        user ? res(user) : rej("Not Logged In!");
      });
    });
  }

  async provider() {
    try {
      const idToken = await this.idToken();
      return idToken ? idToken.claims.provider : null;
    } catch (error) {
      return null;
    }
  }

  async realm() {
    try {
      const idToken = await this.idToken();
      return idToken ? idToken.claims.realm : null;
    } catch (error) {
      // Not logged in
      return null;
    }
  }
  
  suppliedConnection() {
    const connString = this.qps.getRawParam('connection');
    if (!connString) return null;
    try {
      const decoded = decodeURIComponent(connString);
      return JSON.parse(decoded);
    } catch (error) {
      console.error("Invalid supplied connection parameter!");
      return null;
    }
  }

  includeConnectionInRequest(request) {
    const conn = this.suppliedConnection();
    return conn ? { ...request, connection: conn } : request;
  }

  async getProviderSettings (template) {
    const id = template? template.provider : await this.provider();
    if (id) return this.PROVIDERS[id];
    await this.logout(true);
    this.EventService.dispatchEvent(this.EventService.actions.AUTHENTICATE, {error: null});
    throw new Error("Unauthenticated!");
  }
  
  async idToken() {
    try {
      const user = await this.user();
      return user ? user.getIdTokenResult() : null;
    } catch (error) {
      return null;
    }
  }

  async isExpiredSession() {
    return new Promise((res, rej) => {
      this.firebase.auth().onAuthStateChanged(async user => {
        if (user) {
          const jwt = await user.getIdTokenResult();
          const { provider, connectionString } = jwt.claims;
          res(!provider || !connectionString);
        }
      });
    });
  }

  getProfile() {
    return this.firebase.auth().currentUser;
  }

  async updateProfile(profile, user) {
    this._profiles[user.uid] = profile;
    const { email } = profile;
    await user.updateProfile(profile);
    await user.updateEmail(email);
  }

  async login(authData) {

    const authFE = feFunctions(this.firebase).httpsCallable('auth');
    const { realm, provider } = authData;
    const providerLocation = { realm, provider };
    const {
      "data": { firebaseToken, profile }
    } = await authFE({ authData, providerLocation });

    const response = await this.firebase.auth().signInWithCustomToken(firebaseToken);
    const { user, additionalUserInfo } = response;
    await this.updateProfile(profile, user);

    if (additionalUserInfo?.isNewUser) { //run this whenever claims are modified
      await this.firebase.auth().signOut();
      const { "data": { firebaseToken } } = await authFE({ authData, providerLocation });
      await this.firebase.auth().signInWithCustomToken(firebaseToken);
    }

    return response;
  }
  
  async logout(noRedirect, error) {
    const providerId = await this.provider();
    this.firebase.auth().signOut();
    // $state.go is preventing firebase.auth().onAuthStateChanged from firing
    return noRedirect ? true : this.$state.go('login', { provider: providerId, validationErrorMessage: error?.details?.validationErrorMessage }, {});
  }
}
